<template>
  <v-app id="inspire">
    <v-navigation-drawer
      v-model="drawer"
      app
      v-if="currentUserEmail"
    >
      <v-list-item
        two-line
        class="px-0"
      >
        <v-list-item-avatar>
          <img src="https://image.flaticon.com/icons/svg/727/727399.svg" />
        </v-list-item-avatar>

        <v-list-item-content>
          <v-list-item-title>{{ currentUserEmail }}</v-list-item-title>
          <v-list-item-subtitle>{{ userType }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-divider></v-divider>
      <v-list>
        <v-list-item
          v-for="item in items"
          :key="item.title"
          :to="item.link"
        >
          <v-list-item-icon>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item @click="logout">
          <v-list-item-icon>
            <v-icon>mdi-logout</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>登出</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar
      app
      color="blue-grey darken-2"
      dark
    >
      <v-app-bar-nav-icon @click.stop="drawer = !drawer" />
      <v-toolbar-title class="pl-0">嵩豐建設</v-toolbar-title>
    </v-app-bar>

    <v-content>
      <router-view />
    </v-content>
  </v-app>
</template>

<script>
// eslint-disable-next-line no-unused-vars
import firebase from "firebase";

export default {
  name: "App",
  data: () => ({
    currentUserEmail: "",
    drawer: null,
    items: [
      { title: "後台", icon: "mdi-home", link: "/" },
      { title: "未完成", icon: "mdi-close-circle", link: "/uncompleted" },
      { title: "完成", icon: "mdi-checkbox-marked-circle", link: "/completed" },
      { title: "搜尋", icon: "mdi-magnify", link: "/search" },
      { title: "搜尋地址", icon: "mdi-magnify", link: "/search-address" },
      { title: "報表", icon: "mdi-information-outline", link: "/report" }
    ]
  }),
  updated() {
    if (firebase.auth().currentUser) {
      this.currentUserEmail = firebase.auth().currentUser.email;
    }
  },
  methods: {
    logout() {
      // var vm = this;
      firebase
        .auth()
        .signOut()
        .then(function() {
          window.location.href = "/login";
        })
        .catch(function(error) {
          // An error happened.
          console.log(error);
        });
    }
  },
  computed: {
    userType() {
      return this.currentUserEmail.includes("manager")
        ? "主管單位"
        : "工務單位";
    }
  }
};
</script>

<style>
body {
  color: #2f3640;
}

a {
  text-decoration: none;
}
.card--headline {
  display: flex;
  align-items: baseline;
}
</style>
